import React from 'react';
import {connect} from 'react-redux'
import { saveAs } from 'file-saver';
import encoding from 'encoding-japanese';

import Paper from 'material-ui/Paper';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import * as colors from 'material-ui/styles/colors';

import PageBase from '../../../components/PageBase';

import gStyles from '../../../styles'

import * as actions from '../../../actions'
import SystemControllRoumuCsvForm from './SystemControllRoumuCsvForm'
import _ from 'lodash'

import Loading from '../../../components/Loading';

import $ from 'jquery'

import moment from 'moment'
import {clearSubmitErrors, formValueSelector, stopSubmit} from "redux-form";



const validate = (values, kind) => {
  const errors = {}
  const requiredFields = [
      "year"
  ]
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = '必須入力'
    }
  })

  return errors
}


class SystemControllRoumuCsvPage extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      open: false
    }
  }


  componentDidMount() {

    this.props.handleInit()

    $.ajaxTransport("+binary", function (options, originalOptions, jqXHR) {
      // check for conditions and support for blob / arraybuffer response type
      if (window.FormData && ((options.dataType && (options.dataType == 'binary')) || (options.data && ((window.ArrayBuffer && options.data instanceof ArrayBuffer) || (window.Blob && options.data instanceof Blob))))) {
        return {
          // create new XMLHttpRequest
          send: function (headers, callback) {
            // setup all variables
            var xhr = new XMLHttpRequest(),
              url = options.url,
              type = options.type,
              async = options.async || true,
              // blob or arraybuffer. Default is blob
              dataType = options.responseType || "blob",
              data = options.data || null,
              username = options.username || null,
              password = options.password || null;

            xhr.addEventListener('load', function () {
              var data = {};
              data[options.dataType] = xhr.response;
              // make callback and send data
              callback(xhr.status, xhr.statusText, data, xhr.getAllResponseHeaders());
            });

            xhr.open(type, url, async, username, password);

            // setup custom headers
            for (var i in headers) {
              xhr.setRequestHeader(i, headers[i]);
            }

            xhr.responseType = dataType;
            xhr.send(data);
          },
          abort: function () {
            jqXHR.abort();
          }
        };
      }
    });

  }

  handleDownloadEnd() {
    this.setState(Object.assign(this.state, { loading: false }));
  }

  handleDownloadStart() {
    this.setState(Object.assign(this.state, { loading: true }));
  }

  handleDownload(start, end, handleFormCheck) {

    return function (values) {

      if (!handleFormCheck(values)) {
        return;
      }

      start()

      const nvl = (x) => x ? x : ''

      let fileNameSuffix = values.year;
      if (values.month) {
        fileNameSuffix += "_" + values.month
      }

      $.ajax({
        url: `/bg/systemControll/roumuCsv?branchOfficeId=${nvl(values.branchOfficeId)}&departmentId=${nvl(values.departmentId)}&year=${values.year}&month=${values.month || ''}&retiree=${values.retireeCheck ? 1 : 0}`,
        dataType: "text",
        processData: false,
        error: function () {
        },
        success: function (data) {

          end()

          const name = '労務' + "_" + fileNameSuffix + ".csv"

          const unicodeList = [];
          for (let i = 0; i < data.length; i += 1) {
            unicodeList.push(data.charCodeAt(i));
          }

          // 変換処理の実施
          const shiftJisCodeList = encoding.convert(unicodeList, 'sjis', 'unicode');
          const uInt8List = new Uint8Array(shiftJisCodeList);

          // csv書き込みの実装
          const writeData = new Blob([uInt8List], { type: 'text/csv' });

          saveAs(writeData, name);

          return;

          //
          // const mimeType = 'text/csv; charset=SHIFT-JIS'
          //
          // let blob = new Blob([data], {type: mimeType})
          // let downloadUrl = URL.createObjectURL(blob);
          //
          // let a = document.createElement("a");
          // a.href = downloadUrl
          // a.download = name
          // // a.target = '_blank'
          //
          // if (window.navigator.msSaveBlob) {
          //   // for IE
          //   window.navigator.msSaveBlob(blob, name)
          // } else if (window.URL && window.URL.createObjectURL) {
          //   // for Firefox
          //   a.href = window.URL.createObjectURL(blob);
          //   document.body.appendChild(a);
          //   a.click();
          //   document.body.removeChild(a);
          // } else if (window.webkitURL && window.webkitURL.createObject) {
          //   // for Chrome
          //   a.href = window.webkitURL.createObjectURL(blob);
          //   a.click();
          // } else {
          //   // for Safari
          //   window.open('data:' + mimeType + ';base64,' + window.Base64.encode(data), '_blank');
          // }

        },
        type: 'GET'
      });

    }

  }


  handleConfirmOpen() {
    this.setState(Object.assign({}, this.state, {
      open: true
    }))
  }

  handleConfirmClose() {
    this.setState(Object.assign({}, this.state, {
      open: false
    }))
  }

  render() {

    const {
      form,
      selectData,
      selectedBranchOfficeId,
      handleFormCsvCheck,
    } = this.props

    return (

      <PageBase title="労務取得" >

        <div>

          <Paper style={{...gStyles.contentsPaper}}>
            <SystemControllRoumuCsvForm
              initialValues={form}
              selectedBranchOfficeId={selectedBranchOfficeId}
              branchOfficeData={selectData.branchOffice}
              departmentData={selectData.department}
              onDownload={this.handleDownload(this.handleDownloadStart.bind(this), this.handleDownloadEnd.bind(this), handleFormCsvCheck).bind(this)}
            />
          </Paper>

        </div>

        <Loading open={this.state.loading}/>

      </PageBase>

    )
  }

}

const selector = formValueSelector(`systemControllRoumuCsvForm`)
const mapStateToProps = (state) => ({
  form: state.systemControll.form,
  selectData: state.systemControll.selectData,
  selectedBranchOfficeId: selector(state, 'branchOfficeId')
})

const mapStateToDispatch = (dispatch) => ({
  handleInit : () => {dispatch(actions.systemSystemControllRoumuInit())},

  handleFormCsvCheck : (values) => {

    const errors = validate(values)

    if (Object.keys(errors).length) {
      dispatch(stopSubmit(`systemControllRoumuCsvForm`, errors));
      return false
    }

    dispatch(clearSubmitErrors(`systemControllRoumuCsvForm`));

    return true

  },

})

SystemControllRoumuCsvPage = connect(
  mapStateToProps,
  mapStateToDispatch
)(SystemControllRoumuCsvPage)

export default SystemControllRoumuCsvPage;



// WEBPACK FOOTER //
// ./src/containers/master/systemControll/SystemControllRoumuCsvPage.js